import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

// Deep link que registra la app nativa (ver Info.plist y AndroidManifest). El
// backend redirige aqui tras el OAuth y AuthDeepLinkListener canjea el token.
export const NATIVE_OAUTH_REDIRECT = 'maldolor://auth/success';

// Inicia el flujo de Google OAuth.
// - Web: navegacion normal a la ruta relativa del backend (comportamiento previo).
// - Nativo: abre el navegador DEL SISTEMA, no el webview. Google rechaza el OAuth
//   dentro de webviews embebidos ("disallowed_useragent"). Se pide explicitamente
//   el deep link como destino de vuelta.
export async function startGoogleOAuth(): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    const url =
      'https://maldolor.com/api/auth/google?redirect=' +
      encodeURIComponent(NATIVE_OAUTH_REDIRECT);
    await Browser.open({ url });
  } else {
    window.location.href = '/api/auth/google';
  }
}
